import name from './name'

const selectSliceData = state => state[name]
const selectEnvInfo = state => selectSliceData(state).envInfo

export { selectEnvInfo }
